import {Component, OnDestroy, OnInit} from '@angular/core';
import {InfoMessageService} from '../../../services/infomessage/infomessage.service';
import {DoctorService} from '../../../services/doctor/doctor.service';
import {Subject, takeUntil} from 'rxjs';
import {QueryModel} from '../../../services/http/http.service';
import {iResponseList} from '../../../models/response/response.model';
import {DoctorModel} from '../../../models/doctor/doctor.model';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog.component';
import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import {NgClass} from '@angular/common';

@Component({
    selector: 'app-administration-archive',
    imports: [
        CdkAccordion,
        CdkAccordionItem,
        NgClass
    ],
    templateUrl: './administration-archive.component.html',
    styleUrl: './administration-archive.component.sass',
    standalone: true
})
export class AdministrationArchiveComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject<void>()
    deletedDoctorList: DoctorModel[] = [];

    constructor(
        private infoMessageService: InfoMessageService,
        private doctorService: DoctorService,
        private dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
        this.getDeletedDoctors();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    triggerUndelete(doctorId: string): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            closeOnNavigation: true,
            data: {text: 'Soll der Doktor wirklich wiederhergestellt werden ?', header: 'Arzt wiederherstellen', delete: false}
        })

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.undeleteDoctor(doctorId);
            }
        })
    }

    private undeleteDoctor(doctorId: string): void {
        this.doctorService.undeleteDoctor(doctorId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.infoMessageService.createMessage('Doktor erfolgreich wiederhergestellt', 'success');
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    private getDeletedDoctors(): void {
        const query: QueryModel = {
            showDeleted: true
        }
        this.doctorService.getDoctors(query)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<DoctorModel>) => {
                    this.deletedDoctorList = response.data;
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

}
